import {Controller} from "stimulus";
import Choices from "choices.js";

export default class AdminFormInputFilterableSelectController extends Controller<HTMLSelectElement> {
  static values = {
    customLabels: {type: Boolean, default: false},
  };

  declare customLabelsValue: boolean;
  declare choices: Choices;

  connect() {
    this.initFilterableSelect();
    this.element.addEventListener(
      "turbo:morph-element",
      this.refreshFilterableSelect
    );
    this.element.addEventListener("showDropdown", this.handleShowDropdown, false);
  }

  disconnect() {
    this.element.removeEventListener(
      "turbo:morph-element",
      this.refreshFilterableSelect
    );
    this.element.removeEventListener("showDropdown", this.handleShowDropdown, false);
  }

  initFilterableSelect = () => {
    if (this.element.dataset.choice === "active") {
      this.notifyInitialized();
      return;
    }

    if (this.customLabelsValue) {
      // Remove select options and use custom option labels
      [...this.element.options].forEach(el => el.remove());
    }

    this.choices = new Choices(this.element, this.configuration());
    (this.element as any)._choices = this.choices;
    this.notifyInitialized();
  };

  configuration() {
    try {
      return JSON.parse(this.data.get("configuration") || "{}");
    } catch(_) {
      return {};
    }
  }

  private handleShowDropdown = () => {
    const selected = this.choices.getValue() as unknown as {choiceId?: number};
    const id = selected?.choiceId;
    if (!id) return;

    const choices = this.choices as unknown as {
      dropdown: {element: Element};
      choiceList: {scrollToChoice: (option: Element, direction: number) => void};
      _highlightChoice: (option: Element) => void;
    };

    const option = choices.dropdown.element.querySelector(`[data-id="${id}"]`);
    if (!option) return;

    choices.choiceList.scrollToChoice(option, 1);
    choices._highlightChoice(option);
  };

  refreshFilterableSelect = (e: Event) => {
    if (e.target === this.element) setTimeout(this.initFilterableSelect);
  };

  private notifyInitialized() {
    this.element.dispatchEvent(new CustomEvent(
      "admin:filterable-select:initialized",
      {bubbles: true}
    ));
  }
}
